import { createSlice } from "@reduxjs/toolkit";
import addStudyResearch from "@custom/rtk-apis/studyResearch/addStudyResearch";

export interface StudyResearchState {
  data: any;
  status: string;
  loading: boolean;
  msg: string | null;
}

const initialState: StudyResearchState = {
  data: [],
  status: '',
  loading: false,
  msg: null,
};

const addStudyResearchSlice = createSlice({
  name: 'addStudyResearch',
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addStudyResearch.pending, (state) => {
        state.loading = true;
        state.status = 'pending';
        state.msg = null;
      })
      .addCase(addStudyResearch.fulfilled, (state, {payload}) => {
        state.data = payload?.result;
        state.loading = false;
        state.status = payload?.status;
        state.msg = payload?.msg;
      })
      .addCase(addStudyResearch.rejected, (state, {payload}) => {
        state.data = [];
        state.loading = false;
        state.status = 'failure';
        state.msg = typeof payload === 'string' ? payload : 'Failed to add study reserach data.';
      });
  }
});

export default addStudyResearchSlice.reducer;
export const { closeModal } = addStudyResearchSlice.actions;
